var _ellipse, _rect, _path, _path2, _rect2, _circle, _circle2, _circle3, _rect3, _path3, _path4, _circle4, _path5, _circle5, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgHiNoConversationListDark(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 76,
    height: 92,
    viewBox: "0 0 76 92",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ellipse || (_ellipse = /*#__PURE__*/React.createElement("ellipse", {
    cx: 34.5,
    cy: 85.5,
    rx: 34.5,
    ry: 6.5,
    fill: "#353A4B"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 39,
    y: 52,
    width: 8,
    height: 34,
    rx: 2,
    fill: "url(#paint0_linear_6105_69891)"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M76 34C76 24.0589 67.9411 16 58 16H27V54C27 55.6569 28.3431 57 30 57H73C74.6569 57 76 55.6569 76 54V34Z",
    fill: "url(#paint1_linear_6105_69891)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M42 31C42 22.7157 35.2843 16 27 16C18.7157 16 12 22.7157 12 31V54C12 55.6569 13.3431 57 15 57H39C40.6569 57 42 55.6569 42 54V31Z",
    fill: "url(#paint2_linear_6105_69891)"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 59,
    y: 34,
    width: 10,
    height: 2,
    rx: 1,
    fill: "#747989"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 68,
    cy: 6,
    r: 2,
    fill: "url(#paint3_linear_6105_69891)"
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 60,
    cy: 6,
    r: 2,
    fill: "url(#paint4_linear_6105_69891)"
  })), _circle3 || (_circle3 = /*#__PURE__*/React.createElement("circle", {
    cx: 52,
    cy: 6,
    r: 2,
    fill: "url(#paint5_linear_6105_69891)"
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 33,
    y: 12,
    width: 1,
    height: 4,
    fill: "#444A5F"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M35.2471 5.09197C33.6032 4.71738 32.2313 5.56943 31.7069 6.16625C27.7732 8.79207 27.7725 11.8952 28.1666 12.9694C34.4597 13.3275 38 10.4637 38 8.31425C38 6.16479 36.8199 5.45035 35.2471 5.09197Z",
    fill: "url(#paint6_linear_6105_69891)"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M38 4C38 3.6 36.6667 3.16667 36 3L35 4.5C36 4.5 38 4.4 38 4Z",
    fill: "#4B5167"
  })), _circle4 || (_circle4 = /*#__PURE__*/React.createElement("circle", {
    cx: 34,
    cy: 3,
    r: 3,
    fill: "url(#paint7_linear_6105_69891)"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M27.0106 8.57985C28.512 4.80294 32.062 4.35621 33.0732 4.9255C35.9809 6.81529 32.5438 9.22735 30.4618 10.1972C27.3377 11.6503 25.5091 12.3568 27.0106 8.57985Z",
    fill: "url(#paint8_linear_6105_69891)"
  })), _circle5 || (_circle5 = /*#__PURE__*/React.createElement("circle", {
    cx: 35.5,
    cy: 2.5,
    r: 0.5,
    fill: "#2E3343"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_6105_69891",
    x1: 43,
    y1: 52,
    x2: 43,
    y2: 85.0556,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#5B617A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#33384A"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_6105_69891",
    x1: 39.74,
    y1: 17.5375,
    x2: 39.5018,
    y2: 53.9266,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#41475E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#33384A"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_6105_69891",
    x1: 27,
    y1: 16,
    x2: 27,
    y2: 55.8611,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#5B617A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#33384A"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_6105_69891",
    x1: 68,
    y1: 4,
    x2: 68,
    y2: 7.88889,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#5B617A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#33384A"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint4_linear_6105_69891",
    x1: 60,
    y1: 4,
    x2: 60,
    y2: 7.88889,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#5B617A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#33384A"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint5_linear_6105_69891",
    x1: 52,
    y1: 4,
    x2: 52,
    y2: 7.88889,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#5B617A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#33384A"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint6_linear_6105_69891",
    x1: 37,
    y1: 6,
    x2: 30.5,
    y2: 12.5,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#5B617A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#43495E"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint7_linear_6105_69891",
    x1: 34,
    y1: 3.618e-9,
    x2: 34,
    y2: 5.83333,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#5B617A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#43495E"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint8_linear_6105_69891",
    x1: 26.5,
    y1: 10,
    x2: 34.5889,
    y2: 7.2628,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#646B85"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#43495E"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHiNoConversationListDark);
export default __webpack_public_path__ + "static/media/hi-no-conversation-list-dark.d68b3108d81458490fcc9650ded0d1c6.svg";
export { ForwardRef as ReactComponent };